const getElementValue = (item, elementId, parentId, recordIdx) => {
    if (item[elementId])
        return item[elementId]

    if (item.payload && item.payload[elementId]?.value != undefined)
        return item.payload[elementId];
    if (recordIdx != undefined && item.payload && item.payload[parentId]?.value[recordIdx] && item.payload[parentId]?.value[recordIdx][elementId])
        return item.payload[parentId]?.value[recordIdx][elementId]
    if (parentId && item.payload && item.payload[parentId]?.activeRecord?.record != undefined && item.payload[parentId].activeRecord.record[elementId])
        return item.payload[parentId].activeRecord.record[elementId]
    return undefined;
}

const walkConditions = (rule, item, parentId, recordIdx) => {
    try {
        var valid = undefined;
        if (rule.type === "operator") {
            if (rule.rules.length < 2) {
                valid = false;
                return valid;
            } else {
                if (rule.operator === "or") {
                    rule.rules.forEach(function (subRule) {
                        if (valid === true) return;
                        valid = walkConditions(subRule, item, parentId, recordIdx);
                    });
                    return valid;
                }

                if (rule.operator === "and") {
                    rule.rules.forEach(function (subRule) {
                        if (valid === false) return;
                        valid = walkConditions(subRule, item, parentId, recordIdx);
                    });
                    return valid;
                }
            }
        } else if (rule.type === "field") {
            let ruleValue = rule.value;
            let elementValue = getElementValue(item, rule.fieldId, parentId, recordIdx);
            if (elementValue != undefined)
                elementValue = JSON.parse(JSON.stringify(elementValue));
            if (
                rule.operator !== "existe" &&
                rule.operator !== "!existe" &&
                (ruleValue === undefined ||
                    ruleValue === null ||
                    !elementValue)
            ) {
                return false;
            }
            if (rule.operator == "!existe" && elementValue == undefined) {
                return true;
            }

            ruleValue =
                typeof ruleValue === "string" ? ruleValue.toLowerCase() : ruleValue;

            if (
                elementValue.type == "checkbox" && elementValue.value != true
            ) {
                elementValue.value = false;
            }

            if (
                elementValue.type === "checkbox" &&
                (ruleValue === "true" || ruleValue === "si" || ruleValue === true)
            ) {
                ruleValue = true;
            }
            if (elementValue.type === "number") {
                ruleValue = parseFloat(ruleValue);

            }

            if (elementValue.type === "select" || elementValue.type === "multiple") {
                var value = parseFloat(ruleValue);
                if (!isNaN(ruleValue) && !isNaN(value)) ruleValue = value;
            }

            if (
                elementValue.type === "checkbox" &&
                (ruleValue === "false" || ruleValue === "no" || ruleValue === false)
            ) {
                ruleValue = false;
            }
            switch (rule.operator) {
                case "=":
                    if (!elementValue.value && !ruleValue) {
                        return true;
                    }

                    var currentValue =
                        typeof elementValue.value === "string"
                            ? elementValue.value.toLowerCase()
                            : elementValue.value;
                    return currentValue == ruleValue;
                case "!=":
                    var currentValue =
                        typeof elementValue.value === "string"
                            ? elementValue.value.toLowerCase()
                            : elementValue.value;
                    return currentValue != ruleValue;
                case ">":
                    var value = parseFloat(elementValue.value);
                    if (isNaN(value)) return false;
                    return value > ruleValue;
                case "<":
                    var value = parseFloat(elementValue.value);
                    if (isNaN(value)) return false;
                    return value < ruleValue;
                case "<=":
                    var value = parseFloat(item.payload[rule.fieldId].value);
                    if (isNaN(value)) return false;
                    return value <= ruleValue;
                case ">=":
                    var value = parseFloat(elementValue.value);
                    if (isNaN(value)) return false;
                    return value >= ruleValue;
                case "existe":
                    return elementValue.value === null ||
                        elementValue.value === false ||
                        elementValue.value === undefined ||
                        elementValue.value === ""
                        ? false
                        : true;
                case "!existe":
                    return elementValue.value === null ||
                        elementValue.value === false ||
                        elementValue.value === undefined ||
                        elementValue.value === ""
                        ? true
                        : false;
                default:
                    return false;
            }
        }
    } catch (e) { console.log("conditionsIsGo", "Error", e); return false; }
}

const conditionTriggers = (condition, item, parentId, recordIdx) => {
    try {
        if (!condition.valid) return false;

        var valid = condition.conditions.reduce(function (prev, rule) {
            if (prev === false) return prev;
            return walkConditions(rule, item, parentId, recordIdx);
        }, true);

        return valid;
    } catch (e) {
        return false;
    }
}

function conditionIsGo(conditions, item, parentId = null, recordIdx = null) {
    if (!conditions) {
        return;
    }
    return conditions.filter(function (condition) {
        return conditionTriggers(condition, item, parentId, recordIdx);
    }).reduce(function (prev, current) {
        return prev.concat(current.options);
    }, []);
}

export { conditionIsGo };